import { render, staticRenderFns } from "./culturalpro.vue?vue&type=template&id=7e9e22c2&scoped=true&"
import script from "./culturalpro.vue?vue&type=script&lang=js&"
export * from "./culturalpro.vue?vue&type=script&lang=js&"
import style0 from "./culturalpro.vue?vue&type=style&index=0&id=7e9e22c2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9e22c2",
  null
  
)

export default component.exports